import { Reducer } from "redux";

import { SendEmailResponse } from "models/Api/Document";
import { SendEmailFileDispatchTypes } from "models/DispatchTypes/Document";
import { SendEmailActionDispatchTypes } from "constants/Document";

export const initialState: SendEmailResponse = {
  loading: false,
  response: false,
};

const SendEmailReducer: Reducer<
  SendEmailResponse,
  SendEmailFileDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SendEmailActionDispatchTypes.POST_SEND_EMAIL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SendEmailActionDispatchTypes.POST_SEND_EMAIL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SendEmailActionDispatchTypes.POST_SEND_EMAIL_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SendEmailActionDispatchTypes.POST_SEND_EMAIL_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SendEmailReducer;
